<div class="flex justify-between align-items-center mb-4">
    <div class="font-semibold text-xl">
        Cortes con Diferencias del Día
    </div>
    <div>
        <label for="calendar-date" class="font-medium block mb-2"> Fecha </label>
        <p-datepicker inputId="calendar-date" [showIcon]="true" [iconDisplay]="'input'" [readonlyInput]="true"
            appendTo="body" dateFormat="dd/mm/yy" [showButtonBar]="true" [ngModel]="selectedDate"
            (ngModelChange)="onDateChange($event)">
        </p-datepicker>
    </div>
</div>

<p-table [value]="pendingBranches()" [columns]="columns" responsiveLayout="scroll" styleClass="p-datatable-sm"
    scrollHeight="650px">

    <ng-template pTemplate="header" let-columns>
        <tr>
            @for (col of columns; track col.field) {
            <th class="border-bottom-1 surface-border font-semibold">
                {{ col.header }}
            </th>
            }
        </tr>
    </ng-template>

    <ng-template pTemplate="body" let-rowData let-columns="columns">
        <tr>
            @for (col of columns; track col.field) {
            <td [ngClass]="{
                'text-red-600 font-bold':
                    col.field === 'difference' && hasDifference(rowData),
                'text-right': col.isImport
            }">
                @if (col.isImport) {
                    {{ rowData | nestedProperty: col.field | currency:'USD':'symbol':'1.2-2' }}
                } @else {
                    {{ rowData | nestedProperty: col.field }}
                }
            </td>
            }
        </tr>
    </ng-template>

    <ng-template pTemplate="emptymessage">
        <tr>
            <td [attr.colspan]="columns.length" class="py-4 text-gray-500 text-md text-center"
                style="text-align: center;">
                No hay diferencias registradas.
            </td>
        </tr>
    </ng-template>

</p-table>
